import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'   
var swiper = new Swiper(".banner .mySwiper", {
        slidesPerView: 6,
        freeMode: true,
        watchSlidesProgress: true,
    });
var swiper2 = new Swiper(".banner .mySwiper2", {
    thumbs: {
        swiper: swiper,
    },
});

document.addEventListener('DOMContentLoaded', function() {
     
    // 初始化Swiper
    var swiper3 = new Swiper(".section2 .swiper3", {
        direction: "vertical",
        mousewheel: {
            enabled: true,
            releaseOnEdges: true, // 滚动到边缘时释放鼠标滚轮控制
            forceToAxis: true,    // 只允许纵向滚动
            invert: false,
            sensitivity: 1,
            eventsTarget: 'container'
        },
    });
});